export enum DictDataType {
  /**
   * é¡¹ç®åç±»
   */
  CATEGORY = 'category',

  /**
   * è¢«æéæ¹æ¡è¿æ»¤åçé¡¹ç®åç±»
   * @type {any}
   */
  USERCATEGORY = 'userCategory',

  /**
   * åç±»éç½®
   * @type {string}
   */
  CLASSIFICATION = 'classification',

  /**
   * å­¦ä¹ å­æ®
   * @type {string}
   */
  LEARN_CERT_CLASS = 'learnCertClass',

  /**
   * å­¦ä¹ å­æ®é»è®¤å¼éç½®
   * @type {any}
   */
  LEARN_CERT_DEFAULT_CONFIG = 'learnCertDefaultConfig',

  /**
   * å­¦ä¹ å­æ®é»è®¤å¼éç½®
   * @type {any}
   */
  LEARN_CERT_DISABLE_CONFIG = 'learnCertDisableConfig',

  /**
   * å¨é¢ç§å®¤
   */
  TENANT_DEPTS = 'tenant-depts',

  /**
   * èªå·±è¢«å®ä¹ä¸ºç®¡çåçç§å®¤
   * @type {any}
   */
  MY_DEFINED_DEPTS = 'my-defined-depts'
}
